module.exports = __webpack_public_path__ + "static/1-b798dbfa2bfffaa4b886e7c13db4f58f.jpg";